import createReducer from '../../utils/createReducer';

import {
  GET_SOCURE_CAPTURE_ERROR,
  GET_SOCURE_CAPTURE_SUCCESS,
  SOCURE_UPLOAD_DOCUMENT_ERROR,
  SOCURE_VERIFICATION_SUCCESS,
  SOCURE_VERIFICATION_ERROR,
  GET_REQUIRED_DOCUMENTS_SUCCESS,
  GET_REQUIRED_DOCUMENTS_ERROR,
  SOCURE_EVENT_SUCCESS,
  SOCURE_EVENT_ERROR,
} from '../../actions/documents/documentsActionConstants';

const initialState = {
  RequiredDocuments: [],
  SocureCapture: {},
  SocureVerification: {},
  SocureEvent: {},
  error: '',
};

export default createReducer(
  {
    [GET_REQUIRED_DOCUMENTS_SUCCESS]: getRequiredDocuments,
    [GET_REQUIRED_DOCUMENTS_ERROR]: getRequiredDocumentsError,
    [GET_SOCURE_CAPTURE_SUCCESS]: getSocureCapture,
    [GET_SOCURE_CAPTURE_ERROR]: getSocureCaptureError,
    [SOCURE_UPLOAD_DOCUMENT_ERROR]: socureUploadDocumentsError,
    [SOCURE_VERIFICATION_SUCCESS]: socureVerification,
    [SOCURE_VERIFICATION_ERROR]: socureVerificationError,
    [SOCURE_EVENT_SUCCESS]: socureEvent,
    [SOCURE_EVENT_ERROR]: socureEventError,
  },
  initialState,
);

function getRequiredDocuments(state, { payload }) {
  return {
    ...state,
    RequiredDocuments: payload,
    error: '',
  };
}

function getRequiredDocumentsError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function getSocureCapture(state, { payload }) {
  return {
    ...state,
    SocureCapture: payload,
    error: '',
  };
}

function getSocureCaptureError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function socureUploadDocumentsError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function socureVerification(state, { payload }) {
  return {
    ...state,
    SocureVerification: payload,
    error: '',
  };
}

function socureVerificationError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function socureEvent(state, { payload }) {
  return {
    ...state,
    SocureEvent: payload,
    error: '',
  };
}

function socureEventError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}
